import { IAuditedEntity, IsoDateStr, Quantity, Unit } from '@elderbyte/ngx-starter'
import {
  buildEmptyShapePackaging,
  ShapePackaging,
} from '../../packages/bundling/shape/shape-packaging'
import { LabelingSpec } from '../../process/process-plans/process-plan'
import { PropertyConf } from '../../properties/conf/property-conf'
import { DynamicPropertyConf } from '../../properties/dynamic/dynamic-property-conf'
import { CapabilityConf } from './capability/capabilities/capability-config'
import { ItemSortSpec } from './types/items/item-sort-spec'

export class WorkCenter {
  public id?: string // nullable for creation

  public facility: string

  public number: string

  public type: string

  public name?: string

  public description?: string

  public capabilities: CapabilityConf[] = []

  public workStations: string[] = []

  public properties: PropertyConf[] = []

  public dynamicProperties: DynamicPropertyConf[] = []

  public processing: WorkCenterProcessing = new WorkCenterProcessing()

  public packaging: WorkCenterPackaging = new WorkCenterPackaging()

  public labeling: WorkCenterLabeling = new WorkCenterLabeling()

  public assignmentStrategy: WorkCenterAssignmentStrategy

  public itemSortSpec: ItemSortSpec = new ItemSortSpec()

  public audit?: IAuditedEntity // nullable for creation

  public archivedAt: IsoDateStr
}

export class WorkCenterProcessing {
  constructor(public quantityMultipleOf = 1) {}
}

export class WorkCenterPackaging {
  public maxWeight: Quantity = Quantity.zero(Unit.kg)

  public defaultStoragePath?: string

  public packageCalculationEnabled: boolean

  public packagingStrategy: PackagingStrategy = PackagingStrategy.STACK_HORIZONTALLY
  public distributionMode: DistributionMode = DistributionMode.EVEN
  public itemPackageSharing: ItemPackageSharing = ItemPackageSharing.MULTI_COMPLETE

  public maxItemBundleWeight: Quantity = Quantity.zero(Unit.kg)

  public shapePackaging: ShapePackaging = buildEmptyShapePackaging()

  public packageSharingScope?: PackageSharingScope
}

export enum PackagingStrategy {
  STACK_HORIZONTALLY = 'STACK_HORIZONTALLY',
  STACK_ORDERED = 'STACK_ORDERED',
}

export enum DistributionMode {
  EVEN = 'EVEN',
  FILL_UP = 'FILL_UP',
}

export enum ItemPackageSharing {
  SINGLE = 'SINGLE',
  MULTI_COMPLETE = 'MULTI_COMPLETE',
  MULTI_COMPLETE_AND_ONE_PARTIAL = 'MULTI_COMPLETE_AND_ONE_PARTIAL',
  MULTI_COMPLETE_SUB_AND_ONE_PARTIAL = 'MULTI_COMPLETE_SUB_AND_ONE_PARTIAL',
  MULTI = 'MULTI',
}

export class WorkCenterLabeling {
  public batchItemLabelProvisioning: BatchItemLabelProvisioning = BatchItemLabelProvisioning.PRINT
  public labelProvisioningOptions: LabelProvisioningOptions
  public labelingSpec: LabelingSpec
}

export enum BatchItemLabelProvisioning {
  PRINT = 'PRINT',
  CLOUD_FILE = 'CLOUD_FILE',
}

export enum WorkCenterAssignmentStrategy {
  STANDARD = 'STANDARD',
  AVOID = 'AVOID',
  NEVER = 'NEVER',
}

export enum PackageSharingScope {
  WORK_BATCH = 'WORK_BATCH',
  WORK_ORDER_ROUTE = 'WORK_ORDER_ROUTE',
}

export const defaultLabelingProvisionOptions: () => LabelProvisioningOptions = () =>
  <LabelProvisioningOptions>{ excludeContentLabels: false }

export interface LabelProvisioningOptions {
  excludeContentLabels: boolean
}
